import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

const useFormSubmissionHandler = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return async ({
    payload,
    reset,
    closeModal,
    event,
    apiCall,
    itemID,
    afterDone,
    successMessage = 'با موفقیت انجام شد.',
    errorMessage = 'خطایی رخ داد !',
    queryKey = [],
  }) => {
    try {
      const res = await apiCall(payload, itemID);

      if (res?.data?.items?.ResultID > 0) {
        enqueueSnackbar(successMessage);
        if (event.nativeEvent.submitter.name === 'save') {
          closeModal();
          reset();
        }
        queryClient?.invalidateQueries(queryKey);
        afterDone?.();
      } else {
        enqueueSnackbar(res?.data?.items?.Desc, { variant: 'error' });
        // enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('خطا در ارتباط با سرور!', { variant: 'error' });
    }
  };
};

export default useFormSubmissionHandler;
